import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth.js";
import { App } from "./App.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { RastreadorDeRotas } from "./components/RastreadorDeRotas.js";
import { installBreadcrumbs } from "./lib/breadcrumbs.js";
import "./index.css";

// Ouvintes globais da trilha de passos (cliques, campos, erros de JS).
// Antes do render: um erro na PRIMEIRA renderização também precisa entrar
// no relato — é o mais grave e seria justamente o que escaparia.
installBreadcrumbs();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* O boundary envolve TUDO, inclusive os providers: um erro dentro do
        QueryClient ou do AuthProvider derrubaria a árvore da mesma forma,
        e é o caso em que a tela branca aparece antes de qualquer conteúdo. */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <RastreadorDeRotas />
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
